import { LottieControl } from 'Components/ComponentLibrary/Organisms/LottieControl';
import React from 'react';
import { useLottieLoadingContext } from 'Components/ComponentLibrary/Organisms/LottieControl/LottieLoadingLayout';
import PropTypes from 'prop-types';

export const EmailVerificationSentLottie = ({ relationship }) => {
  const { setIsContentShowing } = useLottieLoadingContext();

  React.useEffect(() => {
    setIsContentShowing(false);
  }, []);

  return (
    <LottieControl
      src={relationship.link('related').url()}
      onLoadSuccess={() => setIsContentShowing(true)}
      onLoadError={() => setIsContentShowing(true)}
      height={'auto'}
      width={'auto'}
    />
  );
};

EmailVerificationSentLottie.propTypes = {
  relationship: PropTypes.object.isRequired,
};
